import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Card from '@/components/Card';
import Modal from '@/components/Modal';
import Stack from '@/components/Stack';
import TextStack from '@/components/TextStack';
import { Body } from '@/components/Typography';
import { useResetWorkerPasswordMutation } from '@/graphql';

type Props = {
  workerId: string;
  onClose: () => void;
};

const ResetPasswordModal = ({ workerId, onClose }: Props) => {
  const [resetPassword, { loading }] = useResetWorkerPasswordMutation();
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    try {
      const result = await resetPassword({
        variables: { workerId },
      });

      if (result.data) return onClose();
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : 'Failed to reset password';
      setError(message);
    }
  };

  return (
    <Modal
      disableClickout
      size="sm"
      title="Reset Password"
      onRequestClose={onClose}
    >
      <Card.Section>
        {error && (
          <Alert
            description={error}
            icon={faExclamationTriangle}
            status="danger"
            title="Failed to reset password"
          />
        )}
        <TextStack>
          <Body>
            Are you sure you want to reset the password of this worker?
          </Body>
        </TextStack>
        <Stack justify="end">
          <Button
            a11yLabel="Cancel reset password"
            appearance="outline"
            label="Cancel"
            status="danger"
            type="button"
            onClick={onClose}
          />
          <Button
            a11yLabel="Reset Password"
            isLoading={loading}
            label="Reset"
            loadingLabel="Reseting..."
            onClick={handleSubmit}
          />
        </Stack>
      </Card.Section>
    </Modal>
  );
};

export default ResetPasswordModal;
